import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { FormControl } from '@material-ui/core';

import TitleFont from 'src/components/Typography/TitleFont';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
  datePicker: {
    width: '100%',
    '& .MuiInputBase-root': {
        fontFamily: theme.font.menu,
    }
  },
}));

export default function PeriodCalendarControl(props) {
  const { id, title, selectedDate, handleDateChange, disablePast, disableFuture, minDate, maxDate } = props;

  const classes = useStyles();

  return (
    <FormControl variant="outlined" className={classes.formControl + ' exclude'}>
      <KeyboardDatePicker
        autoOk
        variant="inline"
        inputVariant="outlined"
        label={<TitleFont>{title}</TitleFont>}
        format="MM/DD/YYYY"
        value={selectedDate}
        InputAdornmentProps={{ position: "end" }}
        onChange={handleDateChange}
        className={classes.datePicker}
        id={id}
        disablePast={disablePast}
        disableFuture={disableFuture}
        minDate={minDate}
        maxDate={maxDate}
      />
    </FormControl>
  );
}
